import React from "react";
import "./GettingStarted.css";

const GettingStarted = () => {
  const steps = [
    {
      number: "01",
      title: "Select Package",
      description: "Choose the dosage pack."
    },
    {
      number: "02",
      title: "Place Order",
      description: "Complete your order through our secure checkout process."
    },
    {
      number: "03",
      title: "Delivery",
      description: "Receive your pre-loaded pens delivered discreetly to your door."
    }
  ];

  return (
    <section className="getting-started-section">
      <div className="container">
        <h2 className="section-title">Getting Started Is Simple</h2>
        <div className="steps-grid">
          {steps.map((step, index) => (
            <div key={index} className="step-card">
              <div className="step-number">{step.number}</div>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GettingStarted;